import { useEffect, useState } from "react";
import { useAdvertisements } from "hooks/api/advertisements";
import "./AdvertisementBanner.styles.scss";

const ROTATION_INTERVAL_MS = 10000;

export const AdvertisementBanner: React.FC = () => {
  const { data: advertisements = [] } = useAdvertisements();
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (advertisements.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % advertisements.length);
    }, ROTATION_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [advertisements.length]);

  if (advertisements.length === 0) return null;

  const current = advertisements[currentIndex];
  if (!current.imageUrl) return null;

  if (current.url) {
    return (
      <a
        href={current.url}
        target="_blank"
        rel="noopener noreferrer"
        className="nb-layout-advertisement-banner"
      >
        <img
          src={current.imageUrl}
          alt="Оголошення"
          className="nb-layout-advertisement-banner-img"
        />
      </a>
    );
  }

  return (
    <div className="nb-layout-advertisement-banner">
      <img
        src={current.imageUrl}
        alt="Оголошення"
        className="nb-layout-advertisement-banner-img"
      />
    </div>
  );
};
